<router-outlet></router-outlet>

<hd-loader
    *ngIf="loadingPage$ | async"
    [overlay]="true"
></hd-loader>